__turbopack_context__.v({
  "breadcrumb": "styles-module-scss-module__QvEksa__breadcrumb",
});
